import { FieldType } from 'modules/domains';

export const isFloatFieldType = (type?: FieldType): type is FieldType.FLOAT =>
  type === FieldType.FLOAT;
